import React, { useState, useEffect, useCallback } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import AnimatedSection from './AnimatedSection';

// Import Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Utility untuk mendapatkan URL embed YouTube
const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    let videoId;
    try {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'youtu.be') {
            videoId = urlObj.pathname.slice(1);
        } else if (urlObj.hostname.includes('youtube.com')) {
            if (urlObj.pathname.includes('/embed/')) {
                videoId = urlObj.pathname.split('/embed/')[1];
            } else {
                videoId = urlObj.searchParams.get('v');
            }
        }
    } catch (error) {
        console.error("Invalid URL for YouTube parsing:", error);
        return null;
    }
    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
};

const VideoSection = () => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchVideos = useCallback(async () => {
        setLoading(true);
        try {
            // Mengambil video dari koleksi khusus 'youtubeVideos'
            const videosQuery = query(
                collection(db, 'youtubeVideos'),
                orderBy('date', 'desc'),
                limit(6)
            );
            const videosSnapshot = await getDocs(videosQuery);
            const videosData = videosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setVideos(videosData);
        } catch (error) {
            console.error("Gagal mengambil data video:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchVideos();
    }, [fetchVideos]);

    if (loading) {
        // Anda bisa menambahkan skeleton loader di sini jika mau
        return null;
    }

    if (videos.length === 0) {
        // Jangan tampilkan section jika tidak ada video
        return null;
    }

    return (
        <AnimatedSection>
            <section className="section">
                <div className="container">
                    <h2 style={{ color: 'inherit' }}>Video Youtube</h2>
                    <Swiper
                        modules={[Navigation, Pagination, A11y]}
                        spaceBetween={30}
                        navigation
                        pagination={{ clickable: true }}
                        loop={videos.length > 3}
                        centeredSlides={true}
                        breakpoints={{
                            0: { slidesPerView: 1, spaceBetween: 20 },
                            640: { slidesPerView: 2, spaceBetween: 20 },
                            768: { slidesPerView: 2, spaceBetween: 30 },
                            1024: { slidesPerView: 3, spaceBetween: 30 },
                        }}
                        className="video-slider-container"
                    >
                        {videos.map(video => {
                            const embedUrl = getYouTubeEmbedUrl(video.videoUrl || video.url); // Menggunakan video.videoUrl atau video.url
                            if (!embedUrl) return null;

                            return (
                                <SwiperSlide key={video.id}>
                                    <div className="video-card">
                                        <div className="video-embed-wrapper">
                                            <iframe
                                                src={embedUrl}
                                                title={video.title}
                                                frameBorder="0"
                                                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; accelerometer 'none'; gyroscope 'none'"
                                                allowFullScreen
                                                loading="lazy"
                                            ></iframe>
                                        </div>
                                        <h3 className="video-title">{video.title}</h3>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </section>
        </AnimatedSection>
    );
};

export default VideoSection;
